
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import * as Routines from '../routines';
import * as Api from '../api';
import { AppAction } from '@Safemate/Store/types';
import { AlarmAnalysis } from '@Safemate/DeviceList/Store/types';

function* alarmAnalysis(action: AppAction<number>){
  try{
    const alarmAnalysis: AlarmAnalysis[] = yield call(Api.alarmAnalysis, action.payload);
    yield put(Routines.alarmAnalysis.success({analysis: alarmAnalysis, id: action.payload}));
  }
  catch(e){
    console.log(e)
    yield put(Routines.alarmAnalysis.failure());
  }
}
function* alarmAnalysisSaga(){
    yield takeEvery(Routines.alarmAnalysis.TRIGGER, alarmAnalysis);
}

export default alarmAnalysisSaga;
